__turbopack_context__.v({
  "className": "u-eASq_className",
  "variable": "u-eASq_variable",
});
